import { render, staticRenderFns } from "./ToufangSelfWx.vue?vue&type=template&id=d5c06070&scoped=true&"
import script from "./ToufangSelfWx.vue?vue&type=script&lang=js&"
export * from "./ToufangSelfWx.vue?vue&type=script&lang=js&"
import style0 from "./ToufangSelfWx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ToufangSelfWx.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ToufangSelfWx.vue?vue&type=style&index=2&id=d5c06070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c06070",
  null
  
)

export default component.exports